'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactSelect = require('react-select');var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _components = require('../../components');
var _CompanyField = require('../Company/CompanyContactUs/CompanyField/CompanyField');var _CompanyField2 = _interopRequireDefault(_CompanyField);

var _reduxFormValidators = require('../../helpers/reduxFormValidators');
var _constants = require('../../constants');

var _ProfessionalContactUs = require('./ProfessionalContactUs.scss');var styles = _interopRequireWildcard(_ProfessionalContactUs);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

ProfessionalContactUs = function (_Component) {_inherits(ProfessionalContactUs, _Component);function ProfessionalContactUs() {var _temp, _this, _ret;_classCallCheck(this, ProfessionalContactUs);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.




























    fetchReCaptchaToken = function (evt) {
      _this.props.fetchReCaptchaToken(evt);
      _this.props.handleSubmit(_this.props.onSubmit)(evt);
      return true;
    }, _this.

    formatTypeOptions = function () {return [].concat(Object.values(_constants.PROFESSIONALS_TYPES), ['other']).
      map(function (type) {return {
          label: _react2.default.createElement('span', null, _this.props.translate('professionalsTypes', type)),
          value: type };});}, _this.


    renderTextArea = function (_ref) {var input = _ref.input,meta = _ref.meta,name = _ref.name,placeholder = _ref.placeholder;return (
        _react2.default.createElement(_components.OMTextArea, _extends({
          name: name,
          placeholder: placeholder },
        input, {
          isInvalid: meta.touched && meta.error && !meta.active })));}, _this.



    renderSelect = function (_ref2) {var input = _ref2.input,meta = _ref2.meta;
      var shouldShowError = meta.touched && meta.error && !meta.active;
      var options = _this.formatTypeOptions();
      return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.companyTypeWrap, { 'has-error': shouldShowError }) },
          _react2.default.createElement(_reactSelect2.default, _extends({},
          input, {
            onChange: function onChange(option) {return input.onChange(option.value);},
            options: options,
            searchable: false,
            clearable: false,
            instanceId: 'professional',
            rtl: _this.props.isRtl,
            placeholder: _this.props.translate('professionalContactUs', 'companyType') + ' *',
            className: (0, _classnames2.default)(styles.numbersSelect,
            { not_valid: shouldShowError }) }))));



    }, _temp), _possibleConstructorReturn(_this, _ret);}ProfessionalContactUs.prototype.componentDidMount = function componentDidMount() {if (!this.props.withoutOverflow) {document.body.style.overflow = 'hidden';}};ProfessionalContactUs.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref3) {var formSubmitting = _ref3.formSubmitting,formSubmitted = _ref3.formSubmitted,formError = _ref3.formError;if (this.props.formSubmitting && !formSubmitting && formSubmitted) {this.props.reset();if (!formError) {this.props.showMessage({ message: _react2.default.createElement('div', { className: 'successMessage' }, _react2.default.createElement('span', null, this.props.translate('companyPage', 'contactsForm', 'submitting_success'))), messageModalClassName: 'company-message-modal' });this.props.closeModal();}}};ProfessionalContactUs.prototype.componentWillUnmount = function componentWillUnmount() {document.body.style.overflow = '';};ProfessionalContactUs.prototype.

  render = function render() {
    var translate = this.props.translate('companyPage', 'contactsForm');
    var professionalTranslate = this.props.translate('professionalContactUs');

    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.professionalContactUs, this.props.className) },
        _react2.default.createElement('div', { className: styles.textWrapper },
          _react2.default.createElement('h3', null, professionalTranslate('contactUs')),

          _react2.default.createElement('p', { className: styles.title },
            translate('titleForm')),

          _react2.default.createElement('p', { className: styles.description },
            translate('description'))),



        _react2.default.createElement('form', { noValidate: 'noValidate' },
          _react2.default.createElement('div', { className: styles.horizontalBlock },
            _react2.default.createElement(_reduxForm.Field, {
              name: 'name',
              component: _CompanyField2.default,
              type: 'text',
              placeholder: translate('name') + ' *',
              validate: [_reduxFormValidators.required],
              translateForError: this.props.translate('errorFieldMessages'),
              isRtl: this.props.isRtl }),


            _react2.default.createElement(_reduxForm.Field, {
              name: 'phone',
              component: _CompanyField2.default,
              type: 'tel',
              normalize: function normalize(value) {return value.replace(/[\D]/g, '');},
              placeholder: translate('phone') + ' *',
              validate: [_reduxFormValidators.required, _reduxFormValidators.phoneNumber],
              translateForError: this.props.translate('errorFieldMessages'),
              isRtl: this.props.isRtl })),


          _react2.default.createElement('div', { className: styles.horizontalBlock },
            _react2.default.createElement(_reduxForm.Field, {
              name: 'type',
              component: this.renderSelect,
              validate: [_reduxFormValidators.required] }),


            _react2.default.createElement(_reduxForm.Field, {
              name: 'city',
              component: _CompanyField2.default,
              type: 'text',
              placeholder: translate('city') + ' *',
              validate: [_reduxFormValidators.required],
              translateForError: this.props.translate('errorFieldMessages'),
              isRtl: this.props.isRtl })),


          _react2.default.createElement('div', { className: styles.textAreaWrapper },
            _react2.default.createElement('span', { className: styles.label }, translate('message')),
            _react2.default.createElement(_reduxForm.Field, {
              name: 'message',
              component: this.renderTextArea,
              placeholder: this.props.isModal || this.props.isMobile ? '' + translate('message') : '',
              translateForError: this.props.translate('errorFieldMessages'),
              isRtl: this.props.isRtl })),



          !!this.props.formError &&
          _react2.default.createElement('p', { className: 'message' },
            _react2.default.createElement('span', null,
              translate('submit_fail_message'), ' ', _react2.default.createElement('a', { href: 'mailto:' + _constants.supportEmail }, _constants.supportEmail))),



          _react2.default.createElement(_components.GoogleReCaptcha, {
              locale: this.props.locale,
              fetchToken: this.fetchReCaptchaToken,
              doReset: this.props.formSubmitted,
              captchaIdentifier: this.props.captchaIdentifier },

            this.props.formSubmitting ?
            _react2.default.createElement('button', { type: 'button', className: 'spinner' },
              _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' })) :


            _react2.default.createElement('input', { type: 'submit', value: translate('submit') })))));





  };return ProfessionalContactUs;}(_react.Component);


ProfessionalContactUs.propTypes = {
  closeModal: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  className: _propTypes2.default.string,
  handleSubmit: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  formSubmitting: _propTypes2.default.bool,
  formSubmitted: _propTypes2.default.bool,
  showMessage: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  formError: _propTypes2.default.object,
  initialValues: _propTypes2.default.object,
  // onSubmit will be triggered by redux form there are no validation errors
  onSubmit: _propTypes2.default.func, // eslint-disable-line react/no-unused-prop-types
  reset: _propTypes2.default.func,
  withoutOverflow: _propTypes2.default.bool,
  isModal: _propTypes2.default.bool,
  fetchReCaptchaToken: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  captchaIdentifier: _propTypes2.default.string };exports.default =


(0, _reduxForm.reduxForm)({
  form: 'professional-contact-us',
  enableReinitialize: true })(
ProfessionalContactUs);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfessionalContactUs/ProfessionalContactUs.js
// module id = 2801
// module chunks = 0